// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c8de926f","239":"eab0352a","453":"258b012d","455":"5623ccd3"}[chunkId] + ".chunk.js";
};